import React from "react";
import { kidProduct } from "../rawData/kidsAPI";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActions, Container } from "@mui/material";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { AiOutlineHeart } from "react-icons/ai";

const ProductCards = (props) => {
  console.log(props);
  return (
    <>
      <Box className="container ">
        <Container className="main cardMain ml-auto mr-auto">
          {kidProduct.map((item) => (
            <Card
              sx={{ minwidth: "19rem", marginBottom: 3, position: "relative" }}
            >
              <Typography sx={styling}>
                <Button
                  sx={{
                    fontSize: "1.5rem",
                    alignItems: "center",
                    right: "1rem",
                  }}
                >
                  <AiOutlineHeart />
                </Button>
              </Typography>
              <CardActionArea>
                <CardMedia
                  sx={{ width: "19rem" }}
                  component="img"
                  src={item.image}
                  alt="Image Not Found"
                />
                <CardContent sx={{ padding: "16px 0px 0px 10px" }}>
                  <Typography
                    variant="p"
                    component="div"
                    sx={{ fontSize: 13, fontWeight: "bold" }}
                  >
                    {item.name}
                  </Typography>
                  <Typography variant="p" component="div" sx={{ fontSize: 11 }}>
                    {item.category}
                  </Typography>

                  {item.isDiscount ? (
                    <Typography sx={{ fontSize: "0.9rem" }}>
                      <span style={{ textDecoration: "line-through" }}>
                        234USD
                      </span>
                      <span
                        style={{
                          color: "red",
                          padding: "0.2rem",
                          fontWeight: "bold",
                        }}
                      >
                        123USD
                      </span>
                      <span
                        style={{
                          backgroundColor: "#FEEDED",
                          color: "red",
                          borderRadius: "1rem",
                          padding: "0.3rem",
                        }}
                      >
                        40% OFF
                      </span>
                    </Typography>
                  ) : (
                    <Typography
                      variant="p"
                      component="p"
                      sx={{ fontWeight: "bold", color: "#55CCD6" }}
                    >
                      {item.footer}
                    </Typography>
                  )}
                </CardContent>
                <CardActions>
                  {item.isActive && (
                    <Button
                      sx={{
                        fontSize: 9,
                        border: "1px solid red",
                        borderRadius: 12,
                        padding: "0.2rem",
                        color: "red",
                      }}
                    >
                      {item.code}
                    </Button>
                  )}
                </CardActions>
              </CardActionArea>
            </Card>
          ))}
        </Container>
      </Box>
    </>
  );
};


export default ProductCards;



const styling = {
  position: "absolute",
  zIndex: 1,
  top: "0.3rem",
  right: "1rem",
  backgroundColor: "#fff",
  borderRadius: "50%",
  width: "2rem",
  height: "2rem",
};
